import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import Layout from '../components/Layout';
import BoxConnectAgent from '../components/BoxConnectAgent';
import BoxQueues from '../components/BoxQueues';
import Paineis from '../components/Paineis';

class home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            waitingLength: 0
        }
    }

    _waitingCount = waitingLength => {
        this.setState({ waitingLength })
    }

    render() {

        const queuesListener = this.props.agente?.queues ? 
            _.map( this.props.agente.queues, (v, i) => parseInt(i)) :
            [];

        const abandonFilter = _.filter(this.props.abandoned, val => queuesListener.indexOf(parseInt(val.queue)) >= 0 );   
        const completedFilter = _.filter(this.props.completed, val => queuesListener.indexOf(parseInt(val.queue)) >= 0 );   

        return (
            <Layout>
                <section className="content-header">
                    <h1>
                        Atendimento
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"  onClick={() => {}}><i className="fa fa-dashboard"></i> Home</a></li>
                        <li className="active">Atendimento</li>
                    </ol>
                </section>

                <section className="content">
        
                    <div className="row">
                        <Paineis 
                            size="col-md-4 col-sm-4 col-xs-12"
                            className="info-box-icon bg-yellow"
                            icon="fa fa-meh-o"
                            title="Na filas"
                            value={this.state.waitingLength}
                            tooltip="Ligações em fila aguardando atendimento"
                            />

                        <Paineis
                            size="col-md-4 col-sm-4 col-xs-12" 
                            className="info-box-icon bg-red"
                            icon="fa fa-frown-o"
                            title="Abandonos/ Transferências"
                            value={abandonFilter.length}
                            tooltip="Abandonos e Transferências na Fila: Este item de informação inclui registros de chamadas que não foram atendidas por um agente, representando os abandonos de clientes, bem como casos em que as chamadas foram transferidas (Transbordo) na fila e também não foram atendidas por um agente. Ambos os cenários são considerados como 'não atendidos' para fins de registro e análise"
                            />

                        <Paineis 
                            size="col-md-4 col-sm-4 col-xs-12"
                            className="info-box-icon bg-green"
                            icon="fa fa-smile-o"
                            title="Atendidas"
                            value={completedFilter.length}
                            tooltip="Chamadas atendidas com sucesso"
                            />
                    </div>

                    <div className="row">
                        <div className='col-md-8' >
                            <BoxQueues 
                                queuesListener={queuesListener} 
                                waitingCount={ this._waitingCount }
                                />
                        </div>
                        <div className="col-md-4">
                            <BoxConnectAgent />
                        </div>
                    </div>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return ({
        auth: state.AutenticacaoReducer,
        agente: state.AgentesReducer.agente,
        abandoned: state.QueuesReducer.abandoned,
        completed: state.QueuesReducer.completed,
    })
}
  
  
export default connect(mapStateToProps, null)(home);
